import { ButtonBase } from "@/components/ButtonBase/ButtonBase";
import { CaretRightIcon } from "@/components/Icons/rtlReadyIcons";
import { FlightRouteAndDate } from "@/features/flights/components/flight-purchase/FlightRouteAndDate";
import type { GetFlightAvailabilityTokenFlightV2 } from "@/types/codegen";

type Props = {
  flightDetails: GetFlightAvailabilityTokenFlightV2;
  segmentDirection?: "departure" | "return";
  onClick: () => void;
};

export const FlightButton = ({
  flightDetails,
  segmentDirection,
  onClick,
}: Props) => {
  return (
    <ButtonBase className="flex w-full justify-between" onClick={onClick}>
      <FlightRouteAndDate
        flightDetails={flightDetails}
        segmentDirection={segmentDirection}
      />
      <CaretRightIcon size={16} color="var(--color-stone)" weight="bold" />
    </ButtonBase>
  );
};
